import { Link } from "react-router-dom";
import classes from "./BottomFooter.module.css"

export const BottomFooter = ({ fromKontakt }) => {
    return (
    <footer className={classes.footerContainer} style={{ marginBottom: fromKontakt ? "0" : "" }}>
        <div className={classes.leftContainer}>
            <a href="https://stu-studios.de/info/kontakt">Kontakt</a>
            <Link to="/impressum">Impressum</Link>
            <Link to="/datenschutz">Datenschutz</Link>
            <Link to="/cookie-einstellungen">Cookie Einstellungen</Link>
        </div>     
        <div className={classes.rightContainer}>
            <span>Copyright 2025 Stu.</span>
            <span>All rights reserved</span>
        </div>   
    </footer>
    )
}

export default BottomFooter;
